export default {
  Created: 1,
  NotCreated: 0,
};
